module.exports = __webpack_public_path__ + "img/kl-inafon-logo.ee11660.svg";